<script>
  import { onDestroy } from "svelte";
  import { destroySvelteComponentInstance, mountFederatedSvelteComponent } from "../lib/mountFederatedSvelteComponent";
  import ProjectsTable from "../components/projectsTable.svelte";
  import PageContainer from "../components/shared/PageContainer.svelte";

  let el1;
  let projectsCountInstance = null;

  const mountProjectsCount = async () => {
    const module = await import("App/alaceProjectDetails/count");
    const ProjectsCount = module.default;

    if (el1) {
      projectsCountInstance = mountFederatedSvelteComponent(projectsCountInstance, ProjectsCount, {
        target: el1,
      });
    }
  };

  void mountProjectsCount();

  onDestroy(() => {
    projectsCountInstance = destroySvelteComponentInstance(projectsCountInstance);
  });
</script>

<PageContainer>
  <div class="grid gap-3 w-full">
    <div class="uimodule" bind:this={el1} />
    <div class="uimodule">
      <ProjectsTable />
    </div>
  </div>
</PageContainer>
